export default "__VITE_ASSET__fdsK8CVQ__"